import { useState } from "react";
import { PackageCard } from "../PackageCard";
import { DatePickerCard } from "./DatePickerCard";

interface Package {
    name: string;
    price: number;
    gender: string;
    duration: string;
}

interface PackageDateFlowProps {
    center: string;
    packages: Package[];
    onComplete?: (text: string) => void;
}

export const PackageDateFlow = ({ center, packages, onComplete }: PackageDateFlowProps) => {
    const [selectedPackage, setSelectedPackage] = useState<string | null>(null);

    const handlePackageSelect = (packageName: string) => {
        setSelectedPackage(packageName);
    };

    const handleDateSelect = (packageName: string, dateStr: string) => {
        onComplete?.(
            `I'd like to check availability for ${packageName} on ${dateStr}`,
        );
    };

    return (
        <>
            <PackageCard
                center={center}
                packages={packages}
                onSelect={handlePackageSelect}
                selectedPackage={selectedPackage}
            />
            {selectedPackage && (
                <DatePickerCard
                    packageName={selectedPackage}
                    onDateSelect={handleDateSelect}
                />
            )}
        </>
    );
};
